export enum DepartmentDisplayFormatEnums {
  NUMBER,
  DESCRIPTION,
  NUMBER_DESCRIPTION,
  DESCRIPTION_NUMBER,
}
